import React from "react";
import { usePageHistoryStore } from "../stores/usePageHistoryStore";
import { Loading, PaginationControls } from "components";
import HistoryItem from "./HistoryItem";

// Компонент списку історії сторінки
const HistoryList = () => {
  // Отримуємо дані та дії зі стору
  const logs = usePageHistoryStore((state) => state.logs);
  const isLoading = usePageHistoryStore((state) => state.isLoading);
  const totalCount = usePageHistoryStore((state) => state.totalCount);
  const page = usePageHistoryStore((state) => state.filters.page);
  const pageSize = usePageHistoryStore((state) => state.filters.pageSize);
  const setPage = usePageHistoryStore((state) => state.setPage);

  // Обчислюємо загальну кількість сторінок
  const totalPages = Math.ceil(totalCount / pageSize) || 1;

  return (
    <div className="history-list">
      <h4 className="history-list__title">Історія</h4>
      <div className="history-list__container">
        {isLoading ? (
          <Loading />
        ) : logs.length === 0 ? (
          <div className="history-list__empty">Записів не знайдено.</div>
        ) : (
          <>
            <ul className="history-list__items">
              {logs.map((log) => (
                <HistoryItem key={log.id} log={log} />
              ))}
            </ul>

            {totalPages > 1 && (
              <PaginationControls
                page={page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HistoryList;
